export const hasPermission = (perm, permissions) => {
    return permissions.includes(perm)
};

export const hasGroup = (group, groups) => {
    return groups.includes(group)
};


// WEBPACK FOOTER //
// ./src/common/permissions.js